"use client"

import DashboardContentWrapper from '@/shared/components/dashboard-content-wrapper'
import Link from 'next/link'
import { DASHBOARD_ROUTE } from '@/shared/constants/pages-routes'
import { ChevronLeft } from 'lucide-react'
import Heading from '@/shared/components/ui/typography/heading'
import { StepperContextProvider } from '@/shared/context/stepper-context'
import HomeWithHomeOwnerForm from '@/features/homeowners/components/forms/home-with-home-owner-form'
import CreateHomeWithOwnerFormProvider from '@/features/homeowners/components/forms/providers/create-home-with-owner-form-provider'
import { OrganizationOptionsProvider } from '@/features/homeowners/context/organization-options-context'
import { useRegionAwareHref } from '@/shared/hooks/use-region-aware-href'

function AddHomeownerAndHomeManually() {
  const planningHref = useRegionAwareHref(DASHBOARD_ROUTE.dashboard)

  return (
    <DashboardContentWrapper className="space-y-5 pb-24 md:pb-5">
      <div className="flex items-center gap-0.5">
        <Link href={planningHref}>
          <ChevronLeft className="h-7 w-7" />
        </Link>
        <Heading>Add New Homeowner</Heading>
      </div>
      <StepperContextProvider numberOfSteps={1}>
        <OrganizationOptionsProvider>
          <CreateHomeWithOwnerFormProvider>
            <HomeWithHomeOwnerForm />
          </CreateHomeWithOwnerFormProvider>
        </OrganizationOptionsProvider>
      </StepperContextProvider>
    </DashboardContentWrapper>
  )
}

export default AddHomeownerAndHomeManually

